import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";


const Contact = () => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    subject: "",
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted:", formData);
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="bg-white min-vh-100">
      {/* ===== Header Banner ===== */}
  
      <div
  className="project-header text-center text-black py-5"
  style={{ width: "100%", maxWidth: "1100px", margin: "0 auto"}}
>
  <div className="container">
    <h2 className="fw-bold display-5 mb-3">Our Contact</h2>
    <p
      className="lead mx-auto"
      style={{ maxWidth: "800px" }}
    >
       We’d love to hear from you! Whether you have questions, 
    project inquiries,  our team is here to assist you. Fill out the form below or visit us 
    at our office – we look forward to connecting with you.
    </p>
  </div>
</div>







      {/* ===== Contact Form Section ===== */}
      <main className="container my-5">
   

        <form onSubmit={handleSubmit} className="mx-auto" style={{ maxWidth: "600px" }}>
          {/* Name Field */}
          <div className="mb-4 row align-items-center">
            <label htmlFor="name" className="col-sm-3 col-form-label fw-bold">
              Name:
            </label>
            <div className="col-sm-9">
              <input
                type="text"
                id="name"
                name="name"
                value={formData.name}
                onChange={handleChange}
                className="form-control rounded-pill"
                required
              />
            </div>
          </div>

          {/* Phone Field */}
          <div className="mb-4 row align-items-center">
            <label htmlFor="phone" className="col-sm-3 col-form-label fw-bold">
              Phone No:
            </label>
            <div className="col-sm-9">
              <input
                type="tel"
                id="phone"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className="form-control rounded-pill"
                required
              />
            </div>
          </div>

          {/* Email Field */}
          <div className="mb-4 row align-items-center">
            <label htmlFor="email" className="col-sm-3 col-form-label fw-bold">
              Email ID:
            </label>
            <div className="col-sm-9">
              <input
                type="email"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className="form-control rounded-pill"
                required
              />
            </div>
          </div>

          {/* Subject Field */}
          <div className="mb-4 row">
            <label htmlFor="subject" className="col-sm-3 col-form-label fw-bold pt-2">
              Subject:
            </label>
            <div className="col-sm-9">
              <textarea
                id="subject"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                rows="5"
                className="form-control rounded-4"
                required
              />
            </div>
          </div>

          {/* Submit Button */}
         <div className="text-center pt-3">
  <a
    href="https://wa.me/94775728376"
    target="_blank"
    rel="noopener noreferrer"
    className="btn text-white rounded-pill px-5 py-2 border-0"
    style={{
      background: "linear-gradient(to right, #d4af37, #b8860b)",
      boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
      transition: "all 0.3s ease",
      display: "inline-block",
      textDecoration: "none",
    }}
    onMouseEnter={(e) =>
      (e.target.style.background =
        "linear-gradient(to right, #e5c86c, #c79b2e)")
    }
    onMouseLeave={(e) =>
      (e.target.style.background =
        "linear-gradient(to right, #d4af37, #b8860b)")
    }
  >
    Submit
  </a>
</div>


        </form>
      </main>


       {/* ===== Map Section ===== */}
      <section className="map-section my-5">
        <div className="container">
      
          <div className="map-responsive" style={{ overflow: "hidden", paddingBottom: "56.25%", position: "relative", height: 0 }}>
            <iframe
              title="location-map"
              src={`https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d31568.0!2d80.027937!3d9.689624!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ae259fxxxxxx%3A0xyyyyyyyy!2sThirunelveli%2C%20Jaffna%2C%20Sri%20Lanka!5e0!3m2!1sen!2slk!4v1699999999999`}
              width="600"
              height="450"
              style={{ border: 0, position: "absolute", top: 0, left: 0, width: "100%", height: "100%" }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      
    </div>
  );
};

export default Contact;
